export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";